module.exports = __webpack_public_path__ + "img/fullscreen.157be2f3.svg";